import React from "react";
import { Download, Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PURCHASE_TYPES } from "@/pages/admin/purchases/purchaseHelpers";

export const PurchasesFiltersBar = ({ filters, setFilters, suppliers, onExport, onNewPurchase }) => (
  <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
    <div className="flex items-center gap-2 flex-wrap">
      <div className="relative">
        <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-muted-foreground" />
        <Input data-testid="purchases-search-input" value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} placeholder="Search PO # / supplier..." className="pl-8 w-52" />
      </div>
      <Select value={filters.supplier_id} onValueChange={(v) => setFilters({ ...filters, supplier_id: v })}>
        <SelectTrigger className="w-40"><SelectValue placeholder="Supplier" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All Suppliers</SelectItem>{suppliers.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={filters.purchase_type} onValueChange={(v) => setFilters({ ...filters, purchase_type: v })}>
        <SelectTrigger className="w-40"><SelectValue placeholder="Type" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All Types</SelectItem>{PURCHASE_TYPES.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={filters.payment_status} onValueChange={(v) => setFilters({ ...filters, payment_status: v })}>
        <SelectTrigger className="w-36"><SelectValue placeholder="Payment" /></SelectTrigger>
        <SelectContent><SelectItem value="all">Any Payment</SelectItem><SelectItem value="unpaid">Unpaid</SelectItem><SelectItem value="partial">Partial</SelectItem><SelectItem value="paid">Paid</SelectItem></SelectContent>
      </Select>
      <Input type="date" value={filters.date_from} onChange={(e) => setFilters({ ...filters, date_from: e.target.value })} className="w-36" />
      <Input type="date" value={filters.date_to} onChange={(e) => setFilters({ ...filters, date_to: e.target.value })} className="w-36" />
    </div>
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" className="gap-1" onClick={onExport}><Download className="h-3.5 w-3.5" /> Export CSV</Button>
      <Button data-testid="purchase-add-button" onClick={onNewPurchase} className="gap-2"><Plus className="h-4 w-4" /> New Purchase</Button>
    </div>
  </div>
);
